import React, { Component } from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFButton, VFText } from '@vfgroup-oneplatform/foundation/Components';

import OrderProgressProps from '../../Screens/OrderProgress/OrderProgress.context';
import styles from '../../Screens/OrderProgress/OrderProgress.styles';

class TimelineCard extends Component {
  static contextType = OrderProgressProps;

  renderDataContainer = () => {
    const { updateDate, updateTime } = this.context.orderData;
    const { step } = this.props;

    return (
      <View style={styles.stepDataContainer}>
        {step.image && <Icon name={step.image} size={80} style={styles.stepIcon} />}

        <View>
          <VFText i18nKey="order_progress_timeline_step_update_time" style={styles.stepTitle} />

          <VFText
            i18nKey="%1$s, %2$s"
            placeHolders={[updateDate, updateTime]}
            style={styles.stepDate}
          />
        </View>
      </View>
    );
  };

  renderButton = stepButton => {
    return (
      !!stepButton && (
        <VFButton
          title={stepButton.title}
          type="secondary"
          style={styles.stepButton}
          onPress={stepButton.onPress}
        />
      )
    );
  };

  renderButtonsContainer = hasButtons => {
    const { step } = this.props;

    return (
      hasButtons && (
        <View style={styles.stepButtonsContainer(this.context.theme)}>
          {this.renderButton(step.secondaryButton)}

          {step.primaryButton && step.secondaryButton && <View style={styles.stepButtonsSpace} />}

          {this.renderButton(step.primaryButton)}
        </View>
      )
    );
  };

  render() {
    return (
      <View style={styles.stepContentContainer(this.context.theme)}>
        {this.renderDataContainer()}

        {this.renderButtonsContainer(
          this.props.step.primaryButton || this.props.step.secondaryButton,
        )}
      </View>
    );
  }
}

TimelineCard.propTypes = {
  step: PropTypes.object.isRequired,
};

export default TimelineCard;
